import React from 'react';

import { Card, CardContent, CardHeader, Divider } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';

import { TableGridLocal } from '../../../../../components/TableGridLocal';

type SignalRow = {
  id: string;
  date: string;
  security: string;
  weight: number | string;
  price: number | string;
  execPrice: number | string;
  priceStd: number | string;
  diff: number | string;
  timeDelay: number | string;
  startPL: number | string;
};

const columns: MRT_ColumnDef<SignalRow>[] = [
  { header: 'Сигнал', accessorKey: 'id', enableColumnFilter: false, enableSorting: false },
  { header: 'Дата', accessorKey: 'date', enableColumnFilter: false },
  { header: 'Инструмент', accessorKey: 'security', enableColumnFilter: false },
  { header: 'weight', accessorKey: 'weight', enableColumnFilter: false },
  { header: 'Цена', accessorKey: 'price', enableColumnFilter: false },
  { header: 'execprice', accessorKey: 'execPrice', enableColumnFilter: false },
  { header: 'pricestd', accessorKey: 'priceStd', enableColumnFilter: false },
  { header: 'diff', accessorKey: 'diff', enableColumnFilter: false },
  { header: 'timedelay', accessorKey: 'timeDelay', enableColumnFilter: false },
  { header: 'startPL', accessorKey: 'startPL', enableColumnFilter: false },
];

export const StrategySignalsSection: React.FC = () => {
  return (
    <Card>
      <CardHeader title="Точность следования" />
      <Divider />
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <TableGridLocal name="strategy-signals" columns={columns} data={[]} pageSize={25} totalRowCount={0} />
      </CardContent>
    </Card>
  );
};
